import React, { forwardRef, useEffect } from 'react';
import moment from 'moment';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { t } from 'i18next';
import { toAbsoluteUrl } from '../../../_metronic/helpers';
import { FormatInvoiceDecimalNumber, getValueFromResource, formatDateWithDateAndMonthName } from '../../../common/timeLiveFunction';

const resolveInvoiceLogoSrc = (showLogo: boolean, logoPath: string) => {
    if (!showLogo) {
        return '';
    }
    const path = String(logoPath ?? '').trim();
    const source = path.split('?')[0];
    if (!source || source === 'null' || source === 'undefined') {
        return '';
    }
    return path;
};

const printCss = `
@page {
  size: letter;
  margin: 0 14mm 12mm 14mm;
  @bottom-right {
    content: "Page " counter(page) " of " counter(pages);
    font-family: Verdana;
    font-size: 8pt;
    color: #3a8dc4;
    padding-right: 1.25rem;
    vertical-align: middle;
  }
}
.invoice-footer-spacer { display: none; }
@media print {
  .invoice-footer-spacer { display: block; visibility: hidden; }
  .invoice-footer-fixed { position: fixed; left: calc(2mm + 1.5rem); right: calc(14mm + 1.5rem); bottom: 0; text-align: left; }
  .invoice-footer-fixed .invoiceTableFooterDescription { text-align: left; font-size: 8pt; font-family: Verdana; font-weight: bold; }
  .invoice-page-table > thead { display: table-header-group; }
  .invoice-page-table > tfoot { display: table-footer-group; }
  .invoice-page-table > tbody > tr { break-inside: avoid; page-break-inside: avoid; }
  .invoice-table-header-row { break-after: avoid; page-break-after: avoid; }
  .invoiceTable { table-layout: fixed; width: 100%; }
  .invoiceTable thead { display: table-row-group; }
  .invoiceTable tfoot { display: table-row-group; }
  .invoice-totals-block { break-inside: avoid; page-break-inside: avoid; }
.invoice-company-header .invoice-company-name,
.invoice-company-header .invoice-company-line {
  display: block;
  margin-left: auto;
  margin-top: 0;
  margin-bottom: 0;
  min-height: 12px;
  line-height: 1.1;
  padding-top: 0;
  padding-bottom: 0;
}
}
`;

const InvoicePrintWidgetCustom = forwardRef((props: any, ref: any) => {
    const dispatch = useAppDispatch();
    const { masterRecordArray, timesheetArray, expenseArray, masterArray, taxArray, logoPath } = props;
    const { masterAccountTimeExpenseBilling } = useAppSelector((state) => state.invoiceBilling);
    const { cultureInfoName, decimalPlaces, showProjectNameInInvoiceReport, showBillingRateInInvoiceReport, showEntryDateInInvoiceReport, showEmployeeNameInInvoiceReport, isCompanyOwnLogo, manageTerminologyList } = useAppSelector((state) => state.globalState);
    const getMasterRecord: any = masterAccountTimeExpenseBilling[0];

    useEffect(() => {
    }, []);

    const getLabelNameFromTerminology = (Value: string) => {
        if (manageTerminologyList && manageTerminologyList.length > 0) {
            for (let manageTerminologyItem of manageTerminologyList) {
                let isManageTerminologyExist: boolean = Value.includes(manageTerminologyItem.TerminologyName);
                if (isManageTerminologyExist) {
                    return Value.replace(Value, manageTerminologyItem.UserDefinedName).toString();
                }
            }
        }
        return Value.toString();
    }

    const logoSrc = resolveInvoiceLogoSrc(Boolean(isCompanyOwnLogo), logoPath);
    const footerText = Array.isArray(masterArray.MasterDescription)
        ? masterArray.MasterDescription
            .map((item: any) =>
                String(item ?? '').replace(/\t/g, '    ')
            )
            .join('\n')
        : String(masterArray.MasterDescription ?? '').replace(/\t/g, '    ');

    return (
        <>
            <div ref={ref}>
                <style>{printCss}</style>
                <div className='modal-body pt-0 pb-15 px-5 px-xl-5'>
                    <table className='invoice-page-table' style={{ width: '100%', borderCollapse: 'collapse', border: 0 }}>
                        <thead>
                            <tr>
                                <td style={{ padding: 0, border: 0, verticalAlign: 'top' }}>
                                    <div className='row text-left' style={{ marginTop: 25 }}>
                                    {/* {isCompanyOwnLogo && <img src={logoPath} alt={logoPath} style={{ width: '180px', height: '50px' }} />} */}
                                        <div className='d-flex justify-content-end' style={{ paddingTop: 10, paddingBottom: 10 }}>
                                            <div style={{ width: 180, height: 50 }}>
                                                {logoSrc ? (
                                                    <img
                                                        className='invoice-company-logo'
                                                        src={logoSrc}
                                                        alt=''
                                                        style={{ width: '180px', height: '50px', display: 'block' }}
                                                        onError={(event) => { event.currentTarget.style.visibility = 'hidden'; }}
                                                    />
                                                ) : null}
                                            </div>
                                        </div>
                                        <div style={{ textAlign: 'right' }}>
                                        {/* <span className='invoice-company-name'>{masterArray.AccountName}</span><br /> */}
                                            {/* <span className='invoice-info-right'>{masterArray.AccountAddress1}</span><br />
                                            <span className='invoice-info-right'>{masterArray.AccountAddress2}</span><br />
                                            <span className='invoice-info-right'>{masterArray.City + ' ' + masterArray.ZipCode}</span><br />
                                            <span className='invoice-info-right'>{masterArray.AccountCountry}</span><br />
                                            <span className='invoice-info-right'>{masterArray.Telephone}</span><br /><br /> */}
                                            <div className='invoice-company-header'>
                                                <span className='invoice-company-name'>{masterArray.AccountName}</span>
                                                <span className='invoice-info-right invoice-company-line'>{masterArray.AccountAddress1}</span>
                                                <span className='invoice-info-right invoice-company-line'>{masterArray.AccountAddress2}</span>
                                                <span className='invoice-info-right invoice-company-line'>{masterArray.City + ' ' + masterArray.ZipCode}</span>
                                                <span className='invoice-info-right invoice-company-line'>{masterArray.AccountCountry}</span>
                                                <span className='invoice-info-right invoice-company-line'>{masterArray.Telephone}</span>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </thead>
                        <tfoot>
                            <tr>
                                <td style={{ padding: 0, border: 0 }}>
                                    <div className='invoice-footer-spacer'>
                                        <div className='invoiceTableFooterDescription'>{footerText}</div>
                                    </div>
                                </td>
                            </tr>
                        </tfoot>
                        <tbody>
                            <tr>
                                <td style={{ padding: 0, border: 0, verticalAlign: 'top' }}>
                                    <div className='row text-left mb-3'>
                                        <div style={{ textAlign: 'right' }}>
                                            <span className='invoice-info-right' style={{ width: 84, fontWeight: 'bold', marginTop: 15 }}>
                                                {getValueFromResource('Invoice No.', dispatch, t)}
                                            </span>
                                            <span className='invoice-info-right' style={{ width: 84, fontWeight: 'bold', marginTop: 15 }}>{masterArray.InvoiceNoPrefix === '' ? masterArray.InvoiceNumber : masterArray.InvoiceNoPrefix + '-' + masterArray.InvoiceNumber}</span><br />
                                            <span className='invoice-info-right' style={{ width: 84, fontWeight: 'bold' }}>
                                                {getValueFromResource('Invoice Date:', dispatch, t)}
                                            </span>
                                            <span className='invoice-info-right' style={{ width: 84, fontWeight: 'bold' }}>{masterArray.InvoiceDate}</span><br />
                                            <span className='invoice-info-right' style={{ width: 84, fontWeight: 'bold' }}>
                                                {getValueFromResource('PO Number:', dispatch, t)}
                                            </span>
                                            <span className='invoice-info-right' style={{ width: 84, fontWeight: 'bold' }}>{masterArray.PONumber}</span><br />
                                            <span className='invoice-info-right' style={{ width: 84, fontWeight: 'bold' }}>
                                                {getValueFromResource('Due Date:', dispatch, t)}
                                            </span>
                                            <span className='invoice-info-right' style={{ width: 84, fontWeight: 'bold' }}>{masterArray.DueDate}</span><br />
                                        </div>
                                        <div style={{ marginLeft: 0, marginTop: -28 }}>
                                            <span className='invoice-company-address' style={{ minHeight: 0 }}>
                                                {getValueFromResource('Billing Address :', dispatch, t)}
                                            </span> <br />
                                            <span className='invoice-info-left'>{masterArray.ClientName}</span><br />
                                            <span className='invoice-info-left' style={{ width: 200 }}>{masterArray.Address1}</span><br />
                                            {masterArray.Address2 != "" && <><span className='invoice-info-left'>{masterArray.Address2}</span><br /></>}
                                            <span className='invoice-info-left' style={{ width: 200, marginTop: 16 }}>{`${masterArray.ClientCity} ${masterArray.ClientState} ${masterArray.ClientZipcode}`}</span><br />
                                            <span className='invoice-info-left'>{masterArray.ClientCountry}</span><br />
                                            <span className='invoice-company-address mt-4 mb-4' style={{ minHeight: 0 }}>
                                                {'RE : - ' + masterArray.MasterProjectName}
                                            </span> <br />
                                            <span className='invoice-company-address' style={{ minHeight: 0 }}>
                                                {getValueFromResource('Billing Period', dispatch, t)}
                                            </span> <br />
                                            <span className='invoice-info-left' style={{ width: 84, fontWeight: 'bold', paddingRight: 4 }}>
                                                {getValueFromResource('Start Date:', dispatch, t)}
                                            </span>
                                            <span className='invoice-info-left'>{masterArray.StartDate}</span><br />
                                            <span className='invoice-info-left' style={{ width: 84, fontWeight: 'bold', paddingRight: 4 }}>
                                                {getValueFromResource('End Date:', dispatch, t)}
                                            </span>
                                            <span className='invoice-info-left'>{masterArray.EndDate}</span><br />
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            {timesheetArray.length > 0 && <>
                                <tr className='invoice-table-header-row'>
                                    <td style={{ padding: 0, border: 0 }}>
                                        <table className='invoiceTable'>
                                            <thead>
                                                <tr>
                                                    {showEntryDateInInvoiceReport && (
                                                        <th className='invoiceGridTH' style={{ width: 90 }}>{getValueFromResource('Entry Date', dispatch, t)}</th>
                                                    )}
                                                    {showProjectNameInInvoiceReport && (
                                                        <th className='invoiceGridTH' style={{ width: 90 }}>{getValueFromResource('Project Name', dispatch, t)}</th>
                                                    )}
                                                    {showEmployeeNameInInvoiceReport && (
                                                        <th className='invoiceGridTH' style={{ width: 109 }}>{getValueFromResource('Employee Name', dispatch, t)}</th>
                                                    )}
                                                    <th className='invoiceGridTH' style={{ width: 173 }}>{getValueFromResource('Timesheet Description', dispatch, t)}</th>
                                                    {showBillingRateInInvoiceReport && (
                                                        <th className='invoiceGridTH' style={{ width: 90 }}>{getValueFromResource('Billing Rate', dispatch, t)}</th>
                                                    )}
                                                    <th className='invoiceGridTH' style={{ width: 90 }}>{getValueFromResource('Billing Hours', dispatch, t)}</th>
                                                    <th className='invoiceGridTH' style={{ width: 108 }}>{getValueFromResource('Amount', dispatch, t)}</th>
                                                </tr>
                                            </thead>
                                        </table>
                                    </td>
                                </tr>
                                {timesheetArray.map((item: any, index: number) => (
                                    <tr key={`timesheet-${index}`}>
                                        <td style={{ padding: 0, border: 0 }}>
                                            <table className='invoiceTable'>
                                                <tbody>
                                                    <tr className={index % 2 === 1 ? 'invoiceBody invoice-row-alt' : 'invoiceBody'}>
                                                        {showEntryDateInInvoiceReport && (
                                                            <td className='invoiceTD' style={{ width: 90 }}>
                                                                {item.TimeEntryDate ? moment(item.TimeEntryDate).format('DD/MM/YYYY') : ''}
                                                            </td>
                                                        )}
                                                        {showProjectNameInInvoiceReport && (
                                                            <td className='invoiceTD' style={{ width: 90 }}>{item.ProjectName}</td>
                                                        )}
                                                        {showEmployeeNameInInvoiceReport && (
                                                            <td className='invoiceTD' style={{ width: 109 }}>{item.EmployeeName ? item.EmployeeName : ''}</td>
                                                        )}
                                                        <td className='invoiceTD' style={{ width: 173 }}>{item['Detail Description']}</td>
                                                        {showBillingRateInInvoiceReport && (
                                                            <td className='invoiceTD text-right' style={{ width: 90 }}>
                                                                {item.CurrencyCode + ' ' + FormatInvoiceDecimalNumber(cultureInfoName.toString(), item.ActualBillingRate, decimalPlaces)}
                                                            </td>
                                                        )}
                                                        <td className='invoiceTD text-center' style={{ width: 90 }}>
                                                            {FormatInvoiceDecimalNumber(cultureInfoName.toString(), item.BillHours, 2)}
                                                        </td>
                                                        <td className='invoiceTD text-right' style={{ width: 108 }}>
                                                            {item.CurrencyCode + ' ' + FormatInvoiceDecimalNumber(cultureInfoName.toString(), item.TotalAmount, decimalPlaces)}
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </td>
                                    </tr>
                                ))}
                                <tr>
                                    <td style={{ padding: 0, border: 0 }}>
                                        <table className='invoiceTable mb-9'>
                                            <tfoot>
                                                <tr className='invoiceTfootRow'>
                                                    {showEntryDateInInvoiceReport && <td style={{ width: 90 }}></td>}
                                                    {showProjectNameInInvoiceReport && <td style={{ width: 90 }}></td>}
                                                    {showEmployeeNameInInvoiceReport && <td style={{ width: 109 }}></td>}
                                                    {showBillingRateInInvoiceReport ? (
                                                        <>
                                                            <td style={{ width: 173 }}></td>
                                                            <td className='invoiceTotalLabel' style={{ width: 90 }}>Total:</td>
                                                        </>
                                                    ) : (
                                                        <td className='invoiceTotalLabel' style={{ width: 173 }}>Total:</td>
                                                    )}
                                                    <td className='invoiceTotalValue text-center' style={{ width: 90 }}>
                                                        {FormatInvoiceDecimalNumber(cultureInfoName.toString(), masterArray.TotalBillHours, 2)}
                                                    </td>
                                                    <td className='invoiceTotalValue text-right' style={{ width: 108 }}>
                                                        {masterArray.CurrencyCode + ' ' + FormatInvoiceDecimalNumber(cultureInfoName.toString(), masterArray.TotalTimesheetAmount, decimalPlaces)}
                                                    </td>
                                                </tr>
                                            </tfoot>
                                        </table>
                                    </td>
                                </tr>
                            </>}
                            {expenseArray.length > 0 && <>
                                <tr className='invoice-table-header-row'>
                                    <td style={{ padding: 0, border: 0 }}>
                                        <table className='invoiceTable'>
                                            <thead>
                                                <tr>
                                                    {showProjectNameInInvoiceReport && <th className='invoiceGridTH' style={{ width: 167 }}>
                                                        {getValueFromResource('Project Name', dispatch, t)}
                                                    </th>}
                                                    <th className='invoiceGridTH' style={{ width: 408 }}>
                                                        {getValueFromResource('Expense Description', dispatch, t)}
                                                    </th>
                                                    <th className='invoiceGridTH' style={{ width: 104 }}>
                                                        {getValueFromResource('Billed Amount', dispatch, t)}
                                                    </th>
                                                </tr>
                                            </thead>
                                        </table>
                                    </td>
                                </tr>
                                {expenseArray.map((item: any, index: number) => (
                                    <tr key={`expense-${index}`}>
                                        <td style={{ padding: 0, border: 0 }}>
                                            <table className='invoiceTable'>
                                                <tbody>
                                                    <tr className={index % 2 === 1 ? 'invoiceBody invoice-row-alt' : 'invoiceBody'}>
                                                        {showProjectNameInInvoiceReport && <td className='invoiceTD' style={{ width: 167 }}>{item.ProjectName}</td>}
                                                        <td className='invoiceTD' style={{ width: 408 }}>{item.Description}</td>
                                                        <td className='invoiceTD text-right' style={{ width: 104 }}>{item.CurrencyCode + " " + FormatInvoiceDecimalNumber(cultureInfoName.toString(), item.BilledExpenseAmount, decimalPlaces)}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </td>
                                    </tr>
                                ))}
                                <tr>
                                    <td style={{ padding: 0, border: 0 }}>
                                        <table className='invoiceTable mb-6'>
                                            <tfoot>
                                                <tr className="invoiceTfootRow">
                                                    {showProjectNameInInvoiceReport && <td style={{ width: 167 }}></td>}
                                                    <td className="invoiceTotalLabel text-right" style={{ width: 408 }}>
                                                        Total:
                                                    </td>
                                                    <td className="invoiceTotalValue text-right" style={{ width: 104 }}>
                                                        {masterArray.CurrencyCode +
                                                            " " +
                                                            FormatInvoiceDecimalNumber(
                                                                cultureInfoName.toString(),
                                                                masterArray.TotalExpenseAmount,
                                                                decimalPlaces
                                                            )}
                                                    </td>
                                                </tr>
                                            </tfoot>
                                        </table>
                                    </td>
                                </tr>
                            </>}
                            <tr>
                                <td style={{ padding: 0, border: 0, verticalAlign: 'top' }}>
                                    <br />
                                    {/* <div className='invoice-totals-block' style={{ textAlign: 'right' }}>
                                        <span className='invoice-info-right' style={{ width: 71, fontWeight: 'bold' }}>
                                            {getValueFromResource('Sub Total:', dispatch, t)}
                                        </span>
                                        <span className='invoice-info-right' style={{ width: 110, fontWeight: 'bold' }}>{masterArray.CurrencyCode + " " + FormatInvoiceDecimalNumber(cultureInfoName.toString(), masterArray.SubTotal, decimalPlaces)}</span><br />
                                        <span className='invoice-info-right' style={{ width: 71, fontWeight: 'bold' }}>
                                            {getValueFromResource('Discount', dispatch, t)}
                                        </span>
                                        <span className='invoice-info-right' style={{ width: 110, fontWeight: 'bold' }}>{"- " + masterArray.CurrencyCode + " " + FormatInvoiceDecimalNumber(cultureInfoName.toString(), masterArray.Discount, decimalPlaces)}</span><br />
                                        {taxArray.length > 0 && taxArray[0].TaxCodeName != "null" && taxArray.map((item: any, index: number) => {
                                            return (<React.Fragment key={index}><span className='invoice-info-right' style={{ width: 71, fontWeight: 'bold' }}>
                                                {getValueFromResource(item.TaxCodeName, dispatch, t) + ":"} </span>
                                                <span className='invoice-info-right' style={{ width: 110, fontWeight: 'bold' }}>{masterArray.CurrencyCode + " " + FormatInvoiceDecimalNumber(cultureInfoName.toString(), item.TotalTaxCode, decimalPlaces)}</span><br /></React.Fragment>
                                            )
                                        })}
                                        <span className='mt-2'></span>
                                        <span style={{ borderTop: '1px solid #000000', borderBottom: '1px solid #000000', padding: '3px 0' }}>
                                            <span className='invoice-info-right' style={{ width: 80, fontWeight: 'bold' }}>
                                                {getValueFromResource('Grand Total:', dispatch, t)}
                                            </span>
                                            <span className='invoice-info-right' style={{ width: 110, fontWeight: 'bold' }}>{masterArray.CurrencyCode + " " + FormatInvoiceDecimalNumber(cultureInfoName.toString(), masterArray.GrandTotal, decimalPlaces)}</span>
                                        </span>
                                    </div> */}
                                    <div className='invoice-totals-block' style={{ textAlign: 'right' }}>
                                        <div className='invoice-total-line'>
                                            <span className='invoice-info-right invoice-total-label'>
                                                {getValueFromResource('Sub Total:', dispatch, t)}
                                            </span>
                                            <span className='invoice-info-right invoice-total-value'>{masterArray.CurrencyCode + " " + FormatInvoiceDecimalNumber(cultureInfoName.toString(), masterArray.SubTotal, decimalPlaces)}</span>
                                        </div>
                                        <div className='invoice-total-line'>
                                            <span className='invoice-info-right invoice-total-label'>
                                                {getValueFromResource('Discount', dispatch, t)}
                                            </span>
                                            <span className='invoice-info-right invoice-total-value'>{"- " + masterArray.CurrencyCode + " " + FormatInvoiceDecimalNumber(cultureInfoName.toString(), masterArray.Discount, decimalPlaces)}</span>
                                        </div>
                                        {taxArray.length > 0 && taxArray[0].TaxCodeName != "null" && taxArray.map((item: any, index: number) => {
                                            return (
                                                <div className='invoice-total-line' key={index}>
                                                    <span className='invoice-info-right invoice-total-label'>
                                                        {getValueFromResource(item.TaxCodeName, dispatch, t) + ":"}
                                                    </span>
                                                    <span className='invoice-info-right invoice-total-value'>{masterArray.CurrencyCode + " " + FormatInvoiceDecimalNumber(cultureInfoName.toString(), item.TotalTaxCode, decimalPlaces)}</span>
                                                </div>
                                            )
                                        })}
                                        <div className='invoice-total-line invoice-grand-total-line'>
                                            <span className='invoice-info-right invoice-total-label'>
                                                {getValueFromResource('Grand Total:', dispatch, t)}
                                            </span>
                                            <span className='invoice-info-right invoice-total-value'>{masterArray.CurrencyCode + " " + FormatInvoiceDecimalNumber(cultureInfoName.toString(), masterArray.GrandTotal, decimalPlaces)}</span>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div className='invoice-footer-fixed'>
                        <div className='invoiceTableFooterDescription'>
                            {footerText}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
});
export default InvoicePrintWidgetCustom

// import React, { forwardRef, useEffect } from 'react';
// import moment from 'moment';
// import { useAppDispatch, useAppSelector } from '../../../app/hooks';
// import { t } from 'i18next';
// import { toAbsoluteUrl } from '../../../_metronic/helpers';
// import { FormatInvoiceDecimalNumber, getValueFromResource, formatDateWithDateAndMonthName } from '../../../common/timeLiveFunction';

// const InvoicePrintWidgetCustom = forwardRef((props: any, ref: any) => {
//     const dispatch = useAppDispatch();
//     const { masterRecordArray, timesheetArray, expenseArray, masterArray, taxArray, logoPath } = props;
//     const { masterAccountTimeExpenseBilling } = useAppSelector((state) => state.invoiceBilling);
//     const { cultureInfoName, decimalPlaces, showProjectNameInInvoiceReport, showBillingRateInInvoiceReport, showEntryDateInInvoiceReport, showEmployeeNameInInvoiceReport, isCompanyOwnLogo, manageTerminologyList } = useAppSelector((state) => state.globalState);
//     const getMasterRecord: any = masterAccountTimeExpenseBilling[0];

//     useEffect(() => {
//     }, []);

//     const getLabelNameFromTerminology = (Value: string) => {
//         if (manageTerminologyList && manageTerminologyList.length > 0) {
//             for (let manageTerminologyItem of manageTerminologyList) {
//                 let isManageTerminologyExist: boolean = Value.includes(manageTerminologyItem.TerminologyName);
//                 if (isManageTerminologyExist) {
//                     return Value.replace(Value, manageTerminologyItem.UserDefinedName).toString();
//                 }
//             }
//         }
//         return Value.toString();
//     }

//     return (
//         <>
//             <div ref={ref}>
//                 <div className='modal-body pt-0 pb-15 px-5 px-xl-5'>
//                     <div className='row text-left mb-3' style={{ marginTop: 25 }}>
//                         {isCompanyOwnLogo && <img src={logoPath} alt={logoPath} style={{ width: '180px', height: '50px' }} />}
//                         <div style={{ textAlign: 'right' }}>
//                             <span className='invoice-company-name'>{masterArray.AccountName}</span><br />
//                             <span className='invoice-info-right'>{masterArray.AccountAddress1}</span><br />
//                             <span className='invoice-info-right'>{masterArray.AccountAddress2}</span><br />
//                             <span className='invoice-info-right'>{masterArray.City + ' ' + masterArray.ZipCode}</span><br />
//                             <span className='invoice-info-right'>{masterArray.AccountCountry}</span><br />
//                             {/* <span className='invoice-info-right'>{masterArray.Telephone}</span><br /><br /> */}
//                             <span className='invoice-info-right'>{'+61 390 218 381'}</span><br />
//                             <span className='invoice-info-right' style={{ width: 84, fontWeight: 'bold', marginTop: 15 }}>
//                                 {getValueFromResource('Invoice No.', dispatch, t)}
//                             </span>
//                             <span className='invoice-info-right' style={{ width: 84, fontWeight: 'bold', marginTop: 15 }}>{masterArray.InvoiceNoPrefix === '' ? masterArray.InvoiceNumber : masterArray.InvoiceNoPrefix + '-' + masterArray.InvoiceNumber}</span><br />
//                             <span className='invoice-info-right' style={{ width: 84, fontWeight: 'bold' }}>
//                                 {getValueFromResource('Invoice Date:', dispatch, t)}
//                             </span>
//                             <span className='invoice-info-right' style={{ width: 84, fontWeight: 'bold' }}>{masterArray.InvoiceDate}</span><br />
//                             <span className='invoice-info-right' style={{ width: 84, fontWeight: 'bold' }}>
//                                 {getValueFromResource('PO Number:', dispatch, t)}
//                             </span>
//                             <span className='invoice-info-right' style={{ width: 84, fontWeight: 'bold' }}>{masterArray.PONumber}</span><br />
//                             <span className='invoice-info-right' style={{ width: 84, fontWeight: 'bold' }}>
//                                 {getValueFromResource('Due Date:', dispatch, t)}
//                             </span>
//                             <span className='invoice-info-right' style={{ width: 84, fontWeight: 'bold' }}>{masterArray.DueDate}</span><br />
//                         </div>
//                         <div style={{ marginLeft: 0, marginTop: -28 }}>
//                             <span className='invoice-company-address' style={{ minHeight: 0 }}>
//                                 {getValueFromResource('Billing Address :', dispatch, t)}
//                             </span> <br />
//                             <span className='invoice-info-left'>{masterArray.ClientName}</span><br />
//                             <span className='invoice-info-left' style={{ width: 200 }}>{masterArray.Address1}</span><br />
//                             {masterArray.Address2 != "" && <><span className='invoice-info-left'>{masterArray.Address2}</span><br /></>}
//                             <span className='invoice-info-left' style={{ width: 200, marginTop: 16 }}>{`${masterArray.ClientCity} ${masterArray.ClientState} ${masterArray.ClientZipcode}`}</span><br />
//                             <span className='invoice-info-left'>{masterArray.ClientCountry}</span><br />
//                             <span className='invoice-company-address' style={{ minHeight: 0 }}>
//                                 {getValueFromResource('Billing Period', dispatch, t)}
//                             </span> <br />
//                             <span className='invoice-info-left' style={{ width: 84, fontWeight: 'bold', paddingRight: 4 }}>
//                                 {getValueFromResource('Start Date:', dispatch, t)}
//                             </span>
//                             <span className='invoice-info-left'>{masterArray.StartDate}</span><br />
//                             <span className='invoice-info-left' style={{ width: 84, fontWeight: 'bold', paddingRight: 4 }}>
//                                 {getValueFromResource('End Date:', dispatch, t)}
//                             </span>
//                             <span className='invoice-info-left'>{masterArray.EndDate}</span><br />
//                         </div>
//                     </div>
//                     {timesheetArray.length > 0 &&
//                         <table className='invoiceTable mb-9'>
//                             <thead>
//                                 <tr>
//                                     {showEntryDateInInvoiceReport && (
//                                         <th className='invoiceGridTH' style={{ width: 90 }}>{getValueFromResource('Entry Date', dispatch, t)}</th>
//                                     )}
//                                     {showProjectNameInInvoiceReport && (
//                                         <th className='invoiceGridTH' style={{ width: 90 }}>{getValueFromResource('Project Name', dispatch, t)}</th>
//                                     )}
//                                     {showEmployeeNameInInvoiceReport && (
//                                         <th className='invoiceGridTH' style={{ width: 109 }}>{getValueFromResource('Employee Name', dispatch, t)}</th>
//                                     )}
//                                     <th className='invoiceGridTH' style={{ width: 173 }}>{getValueFromResource('Timesheet Description', dispatch, t)}</th>
//                                     {showBillingRateInInvoiceReport && (
//                                         <th className='invoiceGridTH' style={{ width: 90 }}>{getValueFromResource('Billing Rate', dispatch, t)}</th>
//                                     )}
//                                     <th className='invoiceGridTH' style={{ width: 90 }}>{getValueFromResource('Billing Hours', dispatch, t)}</th>
//                                     <th className='invoiceGridTH' style={{ width: 108 }}>{getValueFromResource('Amount', dispatch, t)}</th>
//                                 </tr>
//                             </thead>
//                             <tbody>
//                                 {timesheetArray.length > 0 && timesheetArray.map((item: any, index: number) => {
//                                     return (
//                                         <tr key={index} className='invoiceBody'>
//                                             {showEntryDateInInvoiceReport && (
//                                                 <td className='invoiceTD'>
//                                                     {item.TimeEntryDate ? moment(item.TimeEntryDate).format('DD/MM/YYYY') : ''}
//                                                 </td>
//                                             )}
//                                             {showProjectNameInInvoiceReport && (
//                                                 <td className='invoiceTD'>{item.ProjectName}</td>
//                                             )}
//                                             {showEmployeeNameInInvoiceReport && (
//                                                 <td className='invoiceTD'>{item.EmployeeName ? item.EmployeeName : ''}</td>
//                                             )}
//                                             <td className='invoiceTD'>{item['Detail Description']}</td>
//                                             {showBillingRateInInvoiceReport && (
//                                                 <td className='invoiceTD text-right'>
//                                                     {item.CurrencyCode + ' ' + FormatInvoiceDecimalNumber(cultureInfoName.toString(), item.ActualBillingRate, decimalPlaces)}
//                                                 </td>
//                                             )}
//                                             <td className='invoiceTD text-center'>
//                                                 {FormatInvoiceDecimalNumber(cultureInfoName.toString(), item.BillHours, 2)}
//                                             </td>
//                                             <td className='invoiceTD text-right'>
//                                                 {item.CurrencyCode + ' ' + FormatInvoiceDecimalNumber(cultureInfoName.toString(), item.TotalAmount, decimalPlaces)}
//                                             </td>
//                                         </tr>
//                                     )
//                                 })}
//                             </tbody>
//                             <tfoot>
//                                 <tr className='invoiceTfootRow'>
//                                     {showEntryDateInInvoiceReport && <td></td>}
//                                     {showEmployeeNameInInvoiceReport && <td></td>}
//                                     {showProjectNameInInvoiceReport && <td></td>}
//                                     {showBillingRateInInvoiceReport ? (
//                                         <>
//                                             <td></td>
//                                             <td className='invoiceTotalLabel'>Total:</td>
//                                         </>
//                                     ) : (
//                                         <td className='invoiceTotalLabel'>Total:</td>
//                                     )}
//                                     <td className='invoiceTotalValue text-center'>
//                                         {FormatInvoiceDecimalNumber(cultureInfoName.toString(), masterArray.TotalBillHours, 2)}
//                                     </td>
//                                     <td className='invoiceTotalValue text-right'>
//                                         {masterArray.CurrencyCode + ' ' + FormatInvoiceDecimalNumber(cultureInfoName.toString(), masterArray.TotalTimesheetAmount, decimalPlaces)}
//                                     </td>
//                                 </tr>
//                             </tfoot>
//                         </table>}
//                     {expenseArray.length > 0 &&
//                         <table className='invoiceTable mb-6'>
//                             <thead>
//                                 <tr>
//                                     {showProjectNameInInvoiceReport && <th className='invoiceGridTH' style={{ width: 167 }}>
//                                         {getValueFromResource('Project Name', dispatch, t)}
//                                     </th>}
//                                     <th className='invoiceGridTH' style={{ width: 408 }}>
//                                         {getValueFromResource('Expense Description', dispatch, t)}
//                                     </th>
//                                     <th className='invoiceGridTH' style={{ width: 104 }}>
//                                         {getValueFromResource('Billed Amount', dispatch, t)}
//                                     </th>
//                                 </tr>
//                             </thead>
//                             <tbody>
//                                 {expenseArray.length > 0 && expenseArray.map((item: any, index: number) => {
//                                     return (
//                                         <tr key={index} className='invoiceBody'>
//                                             {showProjectNameInInvoiceReport && <td className='invoiceTD'>{item.ProjectName}</td>}
//                                             <td className='invoiceTD'>{item.Description}</td>
//                                             <td className='invoiceTD text-right'>{item.CurrencyCode + " " + FormatInvoiceDecimalNumber(cultureInfoName.toString(), item.BilledExpenseAmount, decimalPlaces)}</td>
//                                         </tr>
//                                     )
//                                 })}
//                             </tbody>
//                             <tfoot>
//                                 <tr className="invoiceTfootRow">
//                                     {showProjectNameInInvoiceReport && <td></td>}
//                                     <td className="invoiceTotalLabel text-right">
//                                         Total:
//                                     </td>
//                                     <td className="invoiceTotalValue text-right">
//                                         {masterArray.CurrencyCode +
//                                             " " +
//                                             FormatInvoiceDecimalNumber(
//                                                 cultureInfoName.toString(),
//                                                 masterArray.TotalExpenseAmount,
//                                                 decimalPlaces
//                                             )}
//                                     </td>
//                                 </tr>
//                             </tfoot>
//                         </table>}
//                     <br />
//                     <div style={{ textAlign: 'right' }}>
//                         <span className='invoice-info-right' style={{ width: 71, fontWeight: 'bold' }}>
//                             {getValueFromResource('Sub Total:', dispatch, t)}
//                         </span>
//                         <span className='invoice-info-right' style={{ width: 110, fontWeight: 'bold' }}>{masterArray.CurrencyCode + " " + FormatInvoiceDecimalNumber(cultureInfoName.toString(), masterArray.SubTotal, decimalPlaces)}</span><br />
//                         <span className='invoice-info-right' style={{ width: 71, fontWeight: 'bold' }}>
//                             {getValueFromResource('Discount', dispatch, t)}
//                         </span>
//                         <span className='invoice-info-right' style={{ width: 110, fontWeight: 'bold' }}>{"- " + masterArray.CurrencyCode + " " + FormatInvoiceDecimalNumber(cultureInfoName.toString(), masterArray.Discount, decimalPlaces)}</span><br />
//                         {taxArray.length > 0 && taxArray[0].TaxCodeName != "null" && taxArray.map((item: any, index: number) => {
//                             return (<><span className='invoice-info-right' style={{ width: 71, fontWeight: 'bold' }}>
//                                 {getValueFromResource(item.TaxCodeName, dispatch, t) + ":"} </span>
//                                 <span className='invoice-info-right' style={{ width: 110, fontWeight: 'bold' }}>{masterArray.CurrencyCode + " " + FormatInvoiceDecimalNumber(cultureInfoName.toString(), item.TotalTaxCode, decimalPlaces)}</span><br /></>
//                             )
//                         })}
//                         <span className='mt-2'></span>
//                         <span style={{ borderTop: '1px solid #000000', borderBottom: '1px solid #000000', padding: '3px 0' }}>
//                             <span className='invoice-info-right' style={{ width: 80, fontWeight: 'bold' }}>
//                                 {getValueFromResource('Grand Total:', dispatch, t)}
//                             </span>
//                             <span className='invoice-info-right' style={{ width: 110, fontWeight: 'bold' }}>{masterArray.CurrencyCode + " " + FormatInvoiceDecimalNumber(cultureInfoName.toString(), masterArray.GrandTotal, decimalPlaces)}</span>
//                         </span>
//                     </div>
//                     <div className='invoiceTableFooterDescription'>
//                         {Array.isArray(masterArray.MasterDescription)
//                             ? masterArray.MasterDescription
//                                 .map((item: any) =>
//                                     String(item ?? '').replace(/\t/g, '    ')
//                                 )
//                                 .join('\n')
//                             : String(masterArray.MasterDescription ?? '').replace(/\t/g, '    ')
//                         }
//                     </div>
//                 </div>
//             </div>
//         </>
//     )
// });
// export default InvoicePrintWidgetCustom